import { createRouter, createWebHistory } from 'vue-router'
import MainPage from '@/page/MainPage.vue'
import MainPage2 from '@/page/MainPage2.vue'
import LoginPage from '@/page/LoginPage.vue'
import UsersPage from '@/page/UsersPage.vue'
import SportsStorePage from '@/page/SportsStorePage.vue'
import SportsStoreDetailPage from '@/page/SportsStoreDetailPage.vue'
import SportsStoreEditorPage from '@/page/SportsStoreEditorPage.vue'
import MyPage from '@/page/MyPage.vue'

const routes = [
  {
    path: '/',
    name: 'main',
    component: MainPage
  },
  {
    path: '/main2',
    name: 'main2',
    component: MainPage2
  },
  {
    path: '/login',
    name: 'login',
    component: LoginPage
  },
  {
    path: '/user',
    name: 'user',
    component: UsersPage
  },
  {
    path: '/mypage',
    name: 'mypage',
    component: MyPage
  },
  {
    path: '/sportsstore',
    name: 'sportsstore',
    component: SportsStorePage
  },
  {
    path: '/sportsstoredetail:sportsStoreId',
    name: 'sportsstoredetail',
    component: SportsStoreDetailPage,
    props: route => ({sportsStoreId: route.params.sportsStoreId}),
  },
  {
    path: '/sportsstoreedit',
    name: 'new-sportsstoreedit',
    component: SportsStoreEditorPage
  },
  {
    path: '/sportsstoreedit:sportsStoreId',
    name: 'update-sportsstoreedit',
    component: SportsStoreEditorPage,
    props: route => ({sportsStoreId: route.params.sportsStoreId}),
  },
  {
    path: '/teamclubcircle',
    name: 'teamclubcircle',
    component: () => import('@/page/TeamClubCirclePage.vue')
  },
  {
    path: '/teamclubcircledetail:teamClubCircleId',
    name: 'teamclubcircledetail',
    component: () => import('@/page/TeamClubCircleDetailPage.vue'),
    props: route => ({teamClubCircleId: route.params.teamClubCircleId}),
  },
  {
    path: '/teamclubcircleedit',
    name: 'new-teamclubcircleedit',
    component: () => import('@/page/TeamClubCircleEditorPage.vue')
  },
  {
    path: '/teamclubcircleedit:teamClubCircleId',
    name: 'update-teamclubcircleedit',
    component: () => import('@/page/TeamClubCircleEditorPage.vue'),
    props: route => ({teamClubCircleId: route.params.teamClubCircleId}),
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router